import React from "react";
import styles from "./page3.scss";
import pic1 from "./1.png";
import pic2 from "./2.png";
import logo1 from "./logo1.png";
import logo2 from "./logo2.png";
import pic_mian from "./main.png";

function Page3(props) {
  return (
    <div className={styles["page3"]} ref={props.myRef}>
      <div className={styles["page3-left"]}>
        <div className={styles["page3-left-main"]}>
          <div className={`${styles["page3-left-title"]} animate2-wrapper`}>
            <div
              r="247"
              g="216"
              b="222"
              className={`maskBlock animate2`}
              style={{ background: "rgb(247, 216, 222)" }}
            />
            <div className={styles["page3-left-title-child1"]}>
              Media Matrix
            </div>
            <div className={styles["page3-left-title-child2"]}>2</div>
            <div className={styles["page3-left-title-child3"]}>全媒体矩阵</div>
          </div>

          <img alt="" src={pic_mian} />

          {/* <div className={`${styles['page3-left-desc']} animate1-wrapper`}>
            <div r='247' g='216' b='222' className={`maskBlock animate1`} style={{ background: 'rgb(247, 216, 222)' }} />
            时尚经纬是WOW-TREND旗下的高端教育项目，拥有世界顶尖产业资源及时尚领域明星级师资，是一个以资源为核心竞争力，以教育为切入点，为时尚产业人士搭建独一无二资源的学习平台。<br />
            我们于东京、巴黎、米兰、伦敦、纽约、斯德哥尔摩均布有强势资源点，涵盖：国际设计师工作室对接、欧洲定制工坊资源、一线大牌版师、品牌创始人、艺术总监等高端人才资源。
          </div>

          <div className={styles['page3-left-legends']}>
            <div className={styles['page3-left-legends-item']}>线上课程</div>
            <div className={styles['page3-left-legends-item']}>实操课程</div>
            <div className={styles['page3-left-legends-item']}>海外游学</div>
            <div className={styles['page3-left-legends-item']}>企业内训</div>
          </div>

          <div className={styles['page3-left-pic']}>
            <img src={pic1} />
          </div>

          <div className={styles['page3-left-footer']}>
            <img src={logo1} />
          </div> */}
        </div>
      </div>

      <div className={styles["page3-right"]}>
        <div className={styles["page3-right-main"]}>
          <div className={`${styles["page3-right-title"]} animate2-wrapper`}>
            <div
              r="74"
              g="121"
              b="244"
              className={`maskBlock animate2`}
              style={{ background: "rgb(74, 121, 244)" }}
            />
            <div className={styles["page3-right-title-child1"]}>WOW-MAX</div>
            <div className={styles["page3-right-title-child2"]}>3</div>
            <div className={styles["page3-right-title-child3"]}>设计定制</div>
          </div>

          <div className={`${styles["page3-right-desc"]} animate1-wrapper`}>
            <div
              r="74"
              g="121"
              b="244"
              className={`maskBlock animate1`}
              style={{ background: "rgb(74, 121, 244)" }}
            />
            WOW-MAX(设计定制)是WOW-TREND(热点趋势)旗下一项针对企业产品设计研发需求所开创的整合型服务项目。
            <br />
            通过评估企业现状、定位、消费者画像及需求，提供针对性趋势策略、色彩管理、成衣定制、设计稿定制及图案定制的全案服务，助力企业提高产品竞争力。
          </div>

          <ul className={styles["page3-right-tips"]}>
            <li>趋势策略：定位分析/趋势方案/落地运用</li>
            <li>色彩管理：色盘定制/色彩企划/战略培训</li>
            <li>设计稿定制：效果图/正视图/细节图/工艺单/面辅料单</li>
            <li>成衣定制：定向开发/优质面料/精准纸样/品牌做工</li>
            <li>图案定制：定制花型/花型配色</li>
          </ul>

          <div className={styles["page3-right-pic"]}>
            <img src={pic2} />
          </div>

          <div className={styles["page3-right-footer"]}>
            <img src={logo2} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page3;
